import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./store";
import { Provider } from "react-redux";
import { storage } from "./services/config/storage";

// reset the local storage on startup
storage.destroy.all();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


/**
 * Below is not needed,, just for demo purposes of some features.
 * 
 * You can import GgcLifeCycleManager anywhere and call these functions. Ex: fro many component
 * 
// JUST FOR DEMO, if you are running in game center, you can get the session data from here. Session will consist of data we need to pass in games, ex: user details, stats of previous games, etc.
console.log(GgcLifeCycleManager.getSession());
// If you need to tell the manager that game is ended
GgcLifeCycleManager.sendEndEvent();
// If you need to save any stats, ex any score. These will be available as an object for the game in the game center
GgcLifeCycleManager.sendStatEvent('score', 43);
GgcLifeCycleManager.sendStatEvent('timeTaken', 3212);
GgcLifeCycleManager.sendStatEvent('name entered in form', 'Any Text not just numbers');
GgcLifeCycleManager.sendStatEvent('didCheat', false);
// If you need to just log any message, and want it to be enabled in gama center result or report etc.
GgcLifeCycleManager.sendLogEvent('User changed tab');
GgcLifeCycleManager.sendLogEvent('User pasted the content: ...');
GgcLifeCycleManager.sendLogEvent('Level 4 loaded');
GgcLifeCycleManager.sendLogEvent('any message');
*/